import { Column, Container, Row, SizedBox } from "../CommonBaseComponents";
import CustomIcon from "../image/CustomIcon";
import { C2Text, C3Text, T1Text, T3Text } from "../text/CustomText";
import { Theme } from "../../Theme";

function CustomTextCard({
    icon,
    title,
    mainContent,
    remainCount,
    percentage,
    leftBottomText,
    leftTopText,
    isColorPrimary,
    hasIcon,
    height,
}) {
    let iconSection;
    let arrowIcon;
    let arrowSectionColor;
    let percentageTextColor;

    if (icon === "cashes") {
        iconSection = (
            <SizedBox backgroundColor={Theme.color.neutral100_01} width={"40px"} height={"40px"} borderRadius={"100%"}>
                <CustomIcon iconName={icon} size={"24px"} />
            </SizedBox>
        );
    } else if (icon === "receipt") {
        iconSection = (
            <SizedBox backgroundColor={Theme.color.gray800_01} width={"40px"} height={"40px"} borderRadius={"100%"}>
                <CustomIcon iconName={icon} size={"24px"} />
            </SizedBox>
        );
    } else if (icon === "refresh") {
        iconSection = (
            <SizedBox backgroundColor={Theme.color.teal500_01} width={"40px"} height={"40px"} borderRadius={"100%"}>
                <CustomIcon iconName={icon} size={"24px"} />
            </SizedBox>
        );
    } else if (icon === "red_loader") {
        iconSection = (
            <SizedBox backgroundColor={Theme.color.rose500_01} width={"40px"} height={"40px"} borderRadius={"100%"}>
                <CustomIcon iconName={icon} size={"24px"} />
            </SizedBox>
        );
    } else if (icon === "bank_note") {
        iconSection = (
            <SizedBox backgroundColor={Theme.color.indigo500_01} width={"40px"} height={"40px"} borderRadius={"100%"}>
                <CustomIcon iconName={icon} size={"24px"} />
            </SizedBox>
        );
    } else if (icon === "card_minus") {
        iconSection = (
            <SizedBox backgroundColor={Theme.color.rose500_01} width={"40px"} height={"40px"} borderRadius={"100%"}>
                <CustomIcon iconName={icon} size={"24px"} />
            </SizedBox>
        );
    } else if (icon === "bar_down") {
        iconSection = (
            <SizedBox backgroundColor={Theme.color.teal500_01} width={"40px"} height={"40px"} borderRadius={"100%"}>
                <CustomIcon iconName={icon} size={"24px"} />
            </SizedBox>
        );
    } else if (icon === "trend_up") {
        iconSection = (
            <SizedBox backgroundColor={Theme.color.rose500_01} width={"40px"} height={"40px"} borderRadius={"100%"}>
                <CustomIcon iconName={icon} size={"24px"} />
            </SizedBox>
        );
    } else if (icon === "alert_triangle") {
        iconSection = (
            <SizedBox backgroundColor={Theme.color.rose500_01} width={"40px"} height={"40px"} borderRadius={"100%"}>
                <CustomIcon iconName={icon} size={"24px"} />
            </SizedBox>
        );
    } else if (icon === "green_loader") {
        iconSection = (
            <SizedBox backgroundColor={Theme.color.teal500_007} width={"40px"} height={"40px"} borderRadius={"100%"}>
                <CustomIcon iconName={icon} size={"24px"} />
            </SizedBox>
        );
    } else if (icon === "black_out_grey") {
        iconSection = (
            <SizedBox backgroundColor={Theme.color.gray500_007} width={"40px"} height={"40px"} borderRadius={"100%"}>
                <CustomIcon iconName={icon} size={"24px"} />
            </SizedBox>
        );
    }

    if (percentage > 0) {
        arrowIcon = "up_arrow";
        arrowSectionColor = Theme.color.teal500_007;
        percentageTextColor = Theme.color.teal500;
        if (isColorPrimary) {
            arrowSectionColor = Theme.color.neutral100_01;
            arrowIcon += "_white";
            percentageTextColor = Theme.color.neutral100;
        }
    } else {
        arrowIcon = "down_arrow";
        arrowSectionColor = Theme.color.rose500_01;
        percentageTextColor = Theme.color.rose500;
    }

    if (!hasIcon) {
        return (
            <SizedBox
                border={`1px solid ${Theme.color.gray250}`}
                borderRadius={"16px"}
                width={"100%"}
                height={height ?? "100%"}
                alignItem={"flex-start"}
                justifyContent={"flex-start"}
                padding={"16px"}
                backgroundColor={isColorPrimary ? Theme.color.indigo600 : "transparent"}
            >
                <Column justifyContent={"flex-start"} alignItem={"flex-start"} width={"100%"}>
                    <C2Text fontColor={Theme.color.gray500}>{title}</C2Text>
                    <SizedBox height={"8px"} />
                    <T3Text fontColor={Theme.color.zinc850}>{mainContent}</T3Text>
                    <Row justifyContent={"flex-end"} width={"100%"}>
                        <Column alignItem={leftTopText ? "flex-top" : "flex-end"} justifyContent={"flex-end"}>
                            {percentage && (
                                <>
                                    <SizedBox height={"28px"} />
                                    <Container
                                        backgroundColor={arrowSectionColor}
                                        padding={"6px 5px"}
                                        borderRadius={"6px"}
                                    >
                                        <CustomIcon iconName={arrowIcon} size={"18px"} />
                                        <C3Text fontColor={percentageTextColor}>{Math.abs(percentage)}%</C3Text>
                                    </Container>
                                    <SizedBox height={"6px"} />
                                    <C3Text fontColor={isColorPrimary ? Theme.color.neutral300 : Theme.color.gray500}>
                                        {leftBottomText}
                                    </C3Text>
                                </>
                            )}
                        </Column>
                    </Row>
                </Column>
            </SizedBox>
        );
    }

    return (
        <SizedBox
            border={`1px solid ${Theme.color.gray250}`}
            borderRadius={"16px"}
            width={"100%"}
            height={"100%"}
            alignItem={"flex-start"}
            justifyContent={"flex-start"}
            padding={"16px"}
            backgroundColor={isColorPrimary ? Theme.color.indigo600 : "transparent"}
        >
            <Column justifyContent={"flex-start"} alignItem={"flex-start"} width={"100%"}>
                <Row justifyContent={"space-between"} alignItem={"flex-start"} width={"100%"}>
                    {iconSection}
                    {leftTopText && <C3Text fontColor={Theme.color.gray500}>{leftTopText}</C3Text>}
                </Row>

                <Row justifyContent={"space-between"} width={"100%"}>
                    <Column alignItem={"flex-start"}>
                        <SizedBox height={percentage ? "32px" : "36px"} />
                        <C2Text fontColor={isColorPrimary ? Theme.color.neutral100 : Theme.color.zinc850}>
                            {title}
                        </C2Text>
                        <SizedBox height={"8px"} />
                        <Row>
                            <T1Text fontColor={isColorPrimary ? Theme.color.neutral100 : Theme.color.zinc850}>
                                {mainContent}
                            </T1Text>
                            {remainCount && (
                                <>
                                    <SizedBox width={"4px"} />
                                    <T3Text fontColor={Theme.color.gray500}>/{remainCount}</T3Text>
                                </>
                            )}
                        </Row>
                    </Column>
                    <Column alignItem={leftTopText ? "flex-top" : "flex-end"} justifyContent={"flex-end"}>
                        {percentage && (
                            <>
                                <SizedBox height={"48px"} />
                                <Container backgroundColor={arrowSectionColor} padding={"6px 5px"} borderRadius={"6px"}>
                                    <CustomIcon iconName={arrowIcon} size={"18px"} />
                                    <C3Text fontColor={percentageTextColor}>{Math.abs(percentage)}%</C3Text>
                                </Container>
                                <SizedBox height={"6px"} />
                                <C3Text fontColor={isColorPrimary ? Theme.color.neutral300 : Theme.color.gray500}>
                                    {leftBottomText}
                                </C3Text>
                            </>
                        )}
                    </Column>
                </Row>
            </Column>
        </SizedBox>
    );
}

export default CustomTextCard;
